'use client';

import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';

import { Box, Modal, Button, IconButton, Typography } from '@mui/material';

import { SignInSchema } from 'src/utils/validations';

import { CloseIcon } from 'src/theme/core/components/mui-x-data-grid';

import { Form, Field } from 'src/components/hook-form';
import { useDeleteUserAccount } from 'src/api/user-delete/useDeleteUser';
import { notify } from 'src/utils/helper';
import { useLocale } from 'src/locales';

export function UserDeleteModal({ open, onClose, setDeleteUserOTPModal, setMobileNumber }) {
  const { t } = useLocale();
  const defaultValues = {
    mobileNumber: '',
  };

  const methods = useForm({
    resolver: zodResolver(SignInSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  const { data: deletedUserLoginData, mutateAsync, isPending } = useDeleteUserAccount();

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  useEffect(() => {
    if (deletedUserLoginData?.success) {
      setDeleteUserOTPModal(true);
      setMobileNumber(watch('mobileNumber'));
      onClose?.();
    }
    if (deletedUserLoginData?.error) {
      notify(
        'error',
        deletedUserLoginData?.message || deletedUserLoginData?.error || t('Something_Went_Wrong')
      );
    }
  }, [deletedUserLoginData]);

  const onSubmit = handleSubmit(async (data) => {
    await mutateAsync({ mobileNumber: data?.mobileNumber || '' });
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.modal}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">{t('Delete_Account')}</Typography>
          <IconButton onClick={onClose} aria-label="close modal">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ width: '100%', height: '90%' }}>
          {t('Delete_Account_Notice_One')}
          <br />
          <br />
          {t('Delete_Account_Notice_Two')}
          <br />
          <br />
          <Form methods={methods} onSubmit={onSubmit}>
            <Field.Text name="mobileNumber" label={t('Mobile_Number')} required sx={{ my: 2 }} />

            <Button
              fullWidth
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              loading={isPending}
              disabled={isSubmitting || isPending}
              sx={{
                '& .MuiCircularProgress-root': {
                  color: '#0d9d57', // change loader colour here
                  width: '20px !important',
                  height: '20px !important',
                },
              }}
            >
              {t('Get_OTP')}
            </Button>
          </Form>
        </Box>
      </Box>
    </Modal>
  );
}

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', md: '60%' },
    // height: '90%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 2,
  },
  keyValueContainer: { display: 'flex', gap: 2, width: '100%', justifyContent: 'space-between' },
  key: { color: 'text.secondary' },
  value: { typography: 'subtitle2', textAlign: 'right' },
};
